import { useState, useCallback } from "react";
import axios from "axios";
import { FAST_API_BASE_URL } from "constants";

const useGoogleCalendarStatus = (domainId) => {
  const [hasGoogleCredentials, setHasGoogleCredentials] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [singleCalendarStatus, setSingleCalendarStatus] = useState(null);

  const checkGoogleCredentials = useCallback(async () => {
    if (!domainId) return false;
    
    try {
      setIsLoading(true);

      const credentialsRes = await axios.get(`${FAST_API_BASE_URL}/api/mcp-credentials/google-calendar`, {
        headers: { "DOMAIN-TOKEN": domainId },
      }).catch(() => ({ data: { result: null } }));
      
      const credentials = credentialsRes?.data
      // console.log("Google credentials response:", credentials)
      const hasValidCredentials = credentials?.resultCode === "0" && 
                                 credentials?.resultType==="Success" 
      // console.log("Google credentials check result:", hasValidCredentials)
      setHasGoogleCredentials(hasValidCredentials);
      
      if (hasValidCredentials) {
        try {
          const statusRes = await axios.get(`${FAST_API_BASE_URL}/api/single-calendar/status`, {
            headers: { "DOMAIN-TOKEN": domainId }
          });
          
          if (statusRes.data.success) {
            setSingleCalendarStatus(statusRes.data.data);
          }
        } catch (err) {
          // console.log("Single calendar not configured yet");
          setSingleCalendarStatus(null);
        }
      }
      
      return hasValidCredentials;
    } catch (err) {
      console.error("Failed to check Google credentials:", err);
      setHasGoogleCredentials(false);
      setSingleCalendarStatus(null);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [domainId]);

  return {
    hasGoogleCredentials,
    isLoading,
    singleCalendarStatus,
    checkGoogleCredentials,
    setHasGoogleCredentials,
    setSingleCalendarStatus
  };
};

export default useGoogleCalendarStatus;